<template>
    <div v-loading="loading">
        <div id="printContent" class="print-zone">
            <div class="print-title-view">
                <div class="order-code">
                    <canvas id="canvas" class="qrcode-canvas" style="width: 80px;height: 80px;height: 80px;vertical-align: top;" ref="canva"></canvas>
                    <img class="qrcode-image" :src="imgUrl" v-if="imgUrl" />
                    <!-- <svg id="barcode" /> -->
                </div>

                <div class="print-title">销售出库单</div>

                <div class="order-detail">
                    <div class="right">单号：{{ orderData.OrderCode }}</div>
                    <div class="right">
                        日期：{{ orderData.CreateTime }}
                    </div>
                </div>
            </div>
            <div class="print-table-main">
                <div class="div-table-row">
                    <div class="div-table-cell" style="width: 20%">客户名称</div>
                    <div class="div-table-cell fdzt" style="width: 40%">
                        {{ orderData.EntpCusName }}
                    </div>
                    <div class="div-table-cell bold" style="width: 10%">出库单数</div>
                    <div class="div-table-cell bold" style="width: 30%">
                        {{ orderData.OrderIndex }}
                    </div>
                </div>
                <div class="div-table-row">
                    <div class="div-table-cell" style="width: 20%">客户地址</div>
                    <div class="div-table-cell" style="width: 40%">
                        {{ orderData.FullAddress }}
                    </div>
                    <div class="div-table-cell bold" style="width: 10%">仓库区域</div>
                    <div class="div-table-cell bold" style="width: 30%">
                        {{ orderData.ZoneName }}
                    </div>
                </div>
                <div class="div-table-row">
                    <div class="div-table-cell" style="width: 4%">序</div>
                    <div class="div-table-cell" style="width: 18%">汽配编码</div>
                    <div class="div-table-cell" style="width: 16%">配件名称</div>
                    <div class="div-table-cell" style="width: 10%">配件规格</div>
                    <div class="div-table-cell" style="width: 17%">车型</div>
                    <div class="div-table-cell" style="width: 8%">品牌</div>
                    <div class="div-table-cell" style="width: 8%">出库数</div>
                    <div class="div-table-cell" style="width: 6%">单位</div>
                    <div class="div-table-cell" style="width: 13%">仓位</div>
                </div>
                <div class="div-table-row" v-bind:key="index" v-for="(AP, index) in orderData.DetailList">
                    <div class="div-table-cell" style="width: 4%">
                        {{ Number(index) + 1 }}
                    </div>
                    <div class="div-table-cell" style="width: 18%">{{ AP.APCode }}</div>
                    <div class="div-table-cell" style="width: 16%">
                        {{ AP.GoodName }}
                    </div>
                    <div class="div-table-cell fullCut" style="width: 10%">{{ AP.Size }}</div>
                    <div class="div-table-cell fullCut" style="width: 17%">{{ AP.AutoSerise }}</div>
                    <div class="div-table-cell fullCut" style="width: 8%">{{ AP.Brand }}</div>
                    <div class="div-table-cell" style="width: 8%">{{ AP.Count }}</div>
                    <div class="div-table-cell" style="width: 6%">{{ AP.Unit }}</div>
                    <div class="div-table-cell fullCut" style="width: 13%">{{ AP.GoodsLocation }}</div>
                </div>
                <div class="div-table-row">
                    <div class="div-table-cell" style="width: 4%"></div>
                    <div class="div-table-cell" style="width: 18%"></div>
                    <div class="div-table-cell" style="width: 16%"></div>
                    <div class="div-table-cell pall-count" style="width: 35%">总数量 &nbsp;</div>
                    <div class="div-table-cell" style="width: 8%">{{ allNum }}</div>
                    <div class="div-table-cell" style="width: 6%"></div>
                    <div class="div-table-cell" style="width: 13%"></div>
                </div>
            </div>
            <el-row type="flex" class="order-remark bold">
                <el-col :span="24">出库备注：<span v-if="orderData.Remark">{{ orderData.Remark }}</span></el-col>
            </el-row>
            <el-row type="flex" class="order-remark">
                <el-col :span="6">支付方式：{{ orderData.PayTypeName }}</el-col>
                <el-col :span="6">发货方式：{{ orderData.ShipTypeName }}</el-col>
                <el-col :span="4"> 业务员：{{ nameConfig ? (orderData.SNickName ? orderData.SNickName : orderData.SName) : orderData.SName }}</el-col>
                <el-col :span="4">备货员：</el-col>
            </el-row>
        </div>
        <div class="dialog-footer">
            <div class="sort-set">
                <el-button class="btn-primary" @click="setSortField('sortnum')">原始排序</el-button>
                <el-button class="btn-primary" @click="setSortField('code')">编码排序</el-button>
                <el-button class="btn-primary" @click="setSortField('shelfspace')">仓位排序</el-button>
            </div>
            <div class="re-submit">
                <el-button class="btn-primary" @click="lodopPrint" v-if="!isDefaultSet">打印</el-button>
                <el-button class="btn-primary" @click="printedRecord" v-print="'#printContent'" v-else>打印</el-button>
                <el-button @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
import QRCode from 'qrcode';
import JsBarcode from 'jsbarcode';

export default {
    name: '',
    components: {},
    props: ['printId', 'recordIds'],
    data() {
        return {
            listItemWidth: {
                width: '16.6%'
            },
            userMsg: this.$util.getLocalStorage('userMsg'),
            allPrice: 0,
            allNum: 0,
            orderData: {},
            nameConfig: false,
            imgUrl: '',
            isPreview: false,
            isDefaultSet: false,
            loading: false,
            isPrint: false,
            sortField:'sortnum',
        };
    },
    watch: {
        orderData(value) {
            if (this.imgUrl) return;
            this.$nextTick(function() {
                try {
                    if(value.OrderCode){
                        let canvas = this.$refs.canva;
                        QRCode.toCanvas(
                            canvas,
                            value.OrderCode,
                            {
                                width: 80,
                                height: 80,
                                margin: 0,
                                scrollX: 0,
                                scrollY: 0
                            },
                            function (error) {}
                        );
                        setTimeout(() => {
                            html2canvas(canvas, {
                                width: 80,
                                height: 80,
                                scrollX: 0,
                                scrollY: 0
                            }).then(canvasRes => {
                                var imgData = canvasRes.toDataURL('image/png');
                                this.imgUrl = imgData;
                                canvas.style.display = 'none';
                            });
                        }, 1000);
                    }
                } catch (e) {
                    //
                }
            });
        },
    },
    mounted() {
        let sortField = this.$util.getLocalStorage('saleOut_print_' + this.userMsg.EmployeeId);
        if (sortField) this.sortField = sortField;
        this.getSaleOrder();
        this.getConfigByCodes();
    },
    methods: {
        getConfigByCodes() {
            let codes = ['dyywync','syllqdysz','dyyl'];
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            case 'dyywync':
                                this.nameConfig = result;
                                break;
                            case 'syllqdysz':
                                this.isDefaultSet = result;
                                break;
                            case 'dyyl':
                                this.isPreview = result;
                                break;
                        }
                    }

                }
            });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                let strBodyStyle = `<style>
                        .el-row {
                            margin-bottom: 0;
                        }
                        .print-title-view {
                            width: 762px;
                            position: relative;
                            display: flex;
                            justify-content: space-between;
                            align-items: flex-end;
                            padding: 12px 0;
                        }
                        #barcode{
                            display:none;
                        }
                        .order-code {
                            width: 80px;
                            height: 80px;
                            display: inline-block;
                            vertical-align: top;
                            margin-left:10px;
                        }

                        .qrcode-canvas,.qrcode-image{
                            display:none;
                        }
                        .order-detail {
                            color: #000;
                        }
                        .bold{
                            font-weight: bold;
                        }
                        .order-remark {
                            display: -webkit-flex;
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            margin-left: 10px;
                            margin-right: 10px;
                            padding-top: 10px;
                            color: #000;
                        }
                        .order-setcontent {
                            padding: 0px 0px 15px 0px;
                            color: #000;
                        }
                        .print-title {
                            position: absolute;
                            top: 30%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            max-width: 50%;
                            margin: 0 auto;
                            text-align: center;
                            font-size: 20px;
                            font-weight: bold;
                            color: #000;
                            min-height: 26px;
                        }
                        .dialog-footer {
                            display: -webkit-flex;
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            margin-top: 20px;
                        }

                        .print-zone {
                            width: 200mm;
                        }

                        .print-table-main {
                            width: 762px;
                            font-size: 12px;
                        }
                        .div-table-cell {
                            height: auto;
                            word-break:break-all;
                            line-height: 20px;
                            padding: 5px 0 5px 10px;
                            border-top: 1px solid #000;
                            border-right: 1px solid #000;
                            border-bottom: 1px solid #000;
                            color: #000;
                        }
                        .div-table-row {
                            display: flex;
                            border-left: 1px solid #000;
                            margin: 0;
                            font-size: 14px;
                        }
                        .pall-count {
                            text-align: right;
                            padding-right:20px;
                        }
                        .fullCut{
                            overflow: hidden;
                            text-overflow: clip;
                            white-space: nowrap;
                        }
                        .fdzt {
                            font-size: 14px;
                        }
                    </style>`;

                // LODOP.ADD_PRINT_BARCODE(50, 10, 400, 40, '128Auto', this.orderData.OrderCode);
                // LODOP.SET_PRINT_STYLEA(0, "ShowBarText", 0);
                LODOP.ADD_PRINT_BARCODE(10, 10, 100, 100, 'QRCode', this.orderData.OrderCode);


                let strPrintHtml = strBodyStyle + '<body>' + document.getElementById('printContent').innerHTML + '</body>';

                let contentHeight = document.getElementById('printContent').clientHeight;
                if (contentHeight <= 1080) {
                    LODOP.SET_PRINT_PAGESIZE(3, '210mm', '20mm', ''); // 这里3表示纵向打印且纸高“按内容的高度”；580表示纸宽58mm；45表示页底空白4.5mm
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '100%', strPrintHtml);
                } else {
                    LODOP.SET_PRINT_PAGESIZE(0, '210mm', '286mm', '');
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '98%', strPrintHtml);
                    LODOP.NEWPAGE();
                }
                //选择操作系统中设为“默认”的打印机，“-1”代表默认打印机
                LODOP.SET_PRINTER_INDEX(-1);
                if (this.isPreview) LODOP.PREVIEW();
                //预览
                else LODOP.PRINT(); // 直接打印

                setTimeout(() => {
                    this.printedRecord();
                }, 1000);
            }
        },
        printedRecord() {
            this.loading = true;
            this.$util
                .printedRecord({
                        OrderId: this.printId,
                        Type: 7
                    },true
                )
                .then(res => {
                    this.isPrint = true;
                    this.loading = false;
                })
                .catch(err => {
                    this.loading = false;
                });
        },
        // 取消
        cancel() {
            this.$emit('closeDialog', this.isPrint);
        },
        // 获取表格数据
        getSaleOrder() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetEntpZoneOutOrderOutPrint',
                    data: {
                        EntpOutOId: this.printId,
                        SortField: this.sortField
                    }
                })
                .then(res => {
                    let _allNum = 0;
                    let data = res.data;
                    let DetailList = data.DetailList;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                    }
                    this.allNum = _allNum;
                    this.orderData = res.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        setSortField(field) {
            this.$util.setLocalStorage('saleOut_print_' + this.userMsg.EmployeeId, field);
            this.sortField = field;
            this.getSaleOrder();
        }
    }
};
</script>
<style lang="less" scoped media="print">
.el-row {
    margin-bottom: 0;
}
.print-title-view {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 12px 0;
    .qrcode-canvas,
    .qrcode-image {
        width: 80px;
        height: 80px;
        display: inline-block;
        vertical-align: top;
    }
}
.order-detail {
    color: #000;
}

.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding-top: 10px;
    color: #000;
}
.order-setcontent {
    padding: 0px 0px 15px 0px;
    color: #000;
}
.print-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 50%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
    min-height: 26px;
}
.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
}
.re-submit {
    text-align: right;
}
.sort-set {
    margin-left: 10px;
    .btn-primary {
        background: #ff9900;
        color: white;
        margin-left: 0px;
    }
}
.print-zone {
    width: 210mm;
    margin-left: 2rpx;
}
.bold{
    font-weight: bold;
}
.print-table-main {
    width: 792px;
    margin-left: 1px;
    font-size: 12px;
    .div-table-cell {
        height: auto;
        line-height: 30px;
        padding-left: 10px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        border-bottom: 1px solid #000;
        color: #000;
    }
    .div-table-row {
        border-left: 1px solid #000;
    }
    .pall-count {
        text-align: right;
    }
}
.btn-ctn-left {
    display: flex;
}
.fdzt {
    font-size: 14px;
}
.fullCut{
    overflow: hidden;
    text-overflow: clip;
    white-space: nowrap;
}
</style>
